
















import { Component, Vue, Watch } from 'vue-property-decorator'
import HomeworkViewer from './components/HomeworkViewer.vue'
import { HomeworkController } from '@/services/request.service'

@Component({
  components: {
    HomeworkViewer,
  },
})
export default class HomeWork extends Vue {
  private get isChildRoute(): boolean {
    return this.$route.name !== 'homework'
  }
  private get menuList(): Array<any> {
    return [
      {
        key: 'courseClass',
        label: this.$t('homework.courseClassHomework'),
        dot: this.dot.courseClass ? true : false,
      },
      {
        key: 'CCAClass',
        label: this.$t('homework.CCAClassHomework'),
        dot: this.dot.CCAClass ? true : false,
      },
    ]
  }

  private get type(): any {
    return this.$route.params.classType
  }

  private get dot(): any {
    return this.$store.state.taskDot
  }

  // private checkUnHandIn() {
  //   this.dot = {}
  //   HomeworkController.hasUnHandIn()
  //     .then(res=>{
  //       if(res.data && res.data.length){
  //         if(!res.data.length)return
  //         this.$store.commit('setUnfinishedStatus', true)
  //         res.data.includes('1041') ? this.$set(this.dot, 'courseClass', true) : -1
  //         res.data.includes('1042') ? this.$set(this.dot, 'CCAClass', true) : -1
  //       }
  //     })
  //     .catch(err => console.log(err))
  // }

  @Watch('$route', { immediate: true })
  private onRouteChange(to): void {
    if (to.name === 'homework') {
      if (!to.params.classType) {
        this.$router
          .push({ name: 'homework', params: { classType: 'courseClass' } })
          .catch(err => {})
      } else {
        if (to.params.classType !== 'courseClass' && to.params.classType !== 'CCAClass') {
          this.$router.push({ name: 'notFound' })
        }
      }
    }
  }

  private changeType({ item, key, keyPath }): void {
    this.$router.push({ name: 'homework', params: { classType: key } }).catch(err => {})
  }
}
